import { DatePipe } from '@angular/common';
import { PipeTransform, Injectable, Pipe } from '@angular/core';

@Pipe({
  name: 'replaceDate'
})
@Injectable()
export class ReplaceDate implements PipeTransform {

  constructor(private datePipe: DatePipe) { }

  transform(fechaTabla: string): string {
    let date = '';

    if ( fechaTabla !== '0001-01-01T00:00:00') {
      date = this.datePipe.transform(fechaTabla, 'dd-MM-yyyy hh:mm:ss');
    }
    return date;
  }

}